import { gql } from '@apollo/client/core';

export const ORDER_FISCAL_OPERATION_FIELDS = gql`
  fragment OrderFiscalOperationFields on OrderFiscalOperation {
    timezone
    id
    organization_id
    location_id
    order_id
    refund_id
    operation_type
    status
    acquiring_mode
    bank_payment_status
    kkm_command_status
    failure_kind
    error_code
    error_message
    warning_code
    payment_captured_at
    fiscal_drive_number_masked
    fiscal_document_number
    fiscal_document_sign
    shift_number
    receipt_number
    receipt_url
    fiscalized_at
    prepared_at
    started_at
    reconciliation_required_at
    failed_at
    completed_at
    receipt_kind
    receipt_confirmed_at
    return_command_id
    cash_amount
    workstation {
      id
      workstation_id
      name
    }
  }
`;

export const ORDER_FISCAL_RECEIPT_ITEM_FIELDS = gql`
  fragment OrderFiscalReceiptItemFields on OrderFiscalReceiptItem {
    order_line_id
    position
    title
    quantity
    unit_price
    amount
    vat_rate
    payment_method
    payment_subject
    marking_code
  }
`;

export const ORDER_FISCAL_EXECUTION_FIELDS = gql`
  ${ORDER_FISCAL_OPERATION_FIELDS}
  ${ORDER_FISCAL_RECEIPT_ITEM_FIELDS}

  fragment OrderFiscalExecutionFields on OrderFiscalSettlementExecution {
    id_command
    payload_hash
    terminal_transaction_id
    next_action
    receipt_kind
    settled_at
    fiscal_scan_from
    same_fiscal_drive
    operation {
      ...OrderFiscalOperationFields
    }
    execution_target {
      timezone
      provider
      browser_workstation_id
      kkt_device_id
      terminal_device_id
      settings_version
      kkt_identity_hash
      terminal_identity_hash
    }
    receipt_plan {
      schema_version
      advance_amount
      operation_type
      cashier_name
      currency
      taxation_system
      total_amount
      loyalty_points
      contact {
        email
        phone
      }
      items {
        ...OrderFiscalReceiptItemFields
      }
      payments {
        method
        amount
        tendered_amount
        change_amount
        use_acquiring
        execution_order
      }
    }
  }
`;

export const ORDER_FISCAL_REFUND_EXECUTION_FIELDS = gql`
  ${ORDER_FISCAL_OPERATION_FIELDS}
  ${ORDER_FISCAL_RECEIPT_ITEM_FIELDS}

  fragment OrderFiscalRefundExecutionFields on OrderFiscalRefundExecution {
    id_command
    payload_hash
    next_action
    receipt_kind
    settled_at
    fiscal_scan_from
    same_fiscal_drive
    operation {
      ...OrderFiscalOperationFields
    }
    execution_target {
      timezone
      provider
      browser_workstation_id
      kkt_device_id
      terminal_device_id
      settings_version
      kkt_identity_hash
      terminal_identity_hash
    }
    receipt_plan {
      schema_version
      advance_amount
      operation_type
      cashier_name
      currency
      taxation_system
      total_amount
      items {
        ...OrderFiscalReceiptItemFields
      }
      payments {
        payment_id
        method
        amount
        use_acquiring
        execution_order
        original_rrn
        original_terminal_transaction_id
      }
    }
  }
`;
